import React from 'react';
import Header from '../Components/Header';

const About = ({ setCursorMode }) => {
  
  return (<>
    <Header 
      setCursorMode={setCursorMode}
    />
    About
  </>)
}

export default About;